import ActionsForm from '@/shared/mixins/actionsForm'
import Iconavaliacao from '../../../../../../../../../../../static/img/qma/Icon_avaliacao.svg'
import IconCampoTexto from '../../../../../../../../../../../static/img/qma/IconCampoTexto.svg'
import { toast } from '@/shared/utils/UIHelper'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'addGroup',
  props: ['subEtapa', 'Editar', 'tab', 'equipamento'],
  components: {},
  mixins: [ActionsForm],
  data () {
    return {
      imgAvalicao: Iconavaliacao,
      imgAnexo: IconCampoTexto,
      etapaExistente: false,
      novoEtapa: null,
      nivelPrioridade: null,
      formattedValue: null,
      formattedValueAvaliacao: null,
      tipometadado: false,
      EtapaId: null,
      EditarSub: false,
      subEtapaId: null,
      fluxoEscolhido: null,
      ProximoNivelSubEtapa: null,
      ProximoNivelEtapa: null,
      tipoFluxo: {
        metadado: 1,
        avaliacao: 2
      }
    }
  },
  watch: {
    ProximoNivelEtapa (value) {
      this.nivelPrioridade = value
      this.formattedValueAvaliacao = value
    },
    ProximoNivelSubEtapa (value) {
      if (value != null) {
        this.nivelPrioridade = value
        this.formattedValueAvaliacao = value
      }
    },
    formattedValue (newValue) {
      if (!newValue) {
        this.nivelPrioridade = 0
        this.formattedValue = ''
        return
      }

      // Converte para string antes de usar replace
      let rawValue = String(newValue).replace(/\D/g, '')

      if (!rawValue) {
        this.$nextTick(() => {
          this.nivelPrioridade = 0
          this.formattedValue = ''
        })
        return
      }
      let number = parseFloat(rawValue) / 100 // Converte para decimal real

      // Guarda o número puro para cálculos
      this.nivelPrioridade = number
      this.$nextTick(() => {
        this.formattedValue = number.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).replace(',', '.')
      })
    },
    formattedValueAvaliacao (newValue) {
      if (!newValue) {
        this.nivelPrioridade = 0
        this.formattedValueAvaliacao = ''
        return
      }

      // Remove tudo que não for número
      let rawValue = String(newValue).replace(/\D/g, '')

      if (!rawValue) {
        this.$nextTick(() => {
          this.nivelPrioridade = 0
          this.formattedValueAvaliacao = ''
        })
        return
      }

      let number = parseInt(rawValue, 10)
      this.nivelPrioridade = number

      // Força a atualização na interface
      this.$nextTick(() => {
        this.formattedValueAvaliacao = number.toString()
      })
    }
  },
  mounted () {
  },
  methods: {
    // focarDescricao () {
    //   this.$refs.descricaoTextarea.focus()
    // },
    popUptAddEtapa (id, novatapa, tipometadado, proximoNivelSub, proximoNivelEtapa) {
      this.EtapaId = id
      this.ProximoNivelSubEtapa = proximoNivelSub
      this.ProximoNivelEtapa = proximoNivelEtapa
      this.tipometadado = tipometadado
      this.EditarSub = false
      this.fluxoEscolhido = null
      this.novoEtapa = null
      this.nivelPrioridade = null
      this.etapaExistente = novatapa
      this.$refs['add-nova-etapa'].show()
    },
    popUptEditarEtapa (id, novatapa, nivel, descricao) {
      this.EtapaId = id
      this.EditarSub = false
      this.fluxoEscolhido = null
      this.novoEtapa = descricao
      this.nivelPrioridade = nivel
      this.formattedValue = nivel
      this.formattedValueAvaliacao = nivel
      this.etapaExistente = novatapa
      this.$refs['add-nova-etapa'].show()
    },
    popUptSubEditarEtapa (id, novatapa, nivel, descricao, subId) {
      this.EditarSub = true
      this.formattedValue = nivel
      this.formattedValueAvaliacao = nivel
      this.EtapaId = id
      this.subEtapaId = subId
      this.fluxoEscolhido = null
      this.novoEtapa = descricao
      this.nivelPrioridade = nivel
      this.etapaExistente = novatapa
      this.$refs['add-nova-etapa'].show()
    },
    fecharPopUptAdd () {
      this.EtapaId = null
      this.$refs['add-nova-etapa'].hide()
    },

    fluxoTipoEscolhido (value) {
      if (value === this.tipoFluxo.metadado) {
        this.fluxoEscolhido = true
      } else {
        this.fluxoEscolhido = false
      }
      let fluxo = { ...this.tipoFluxo }

      for (var key in fluxo) {
        if (fluxo[key] === value) {
          delete fluxo[key]
        }
      }

      for (var keys in fluxo) {
        let id = fluxo[keys]

        var verificaItemAtivo = document.getElementById(id)
        if (verificaItemAtivo) {
          var isClicked = verificaItemAtivo.classList.contains('clicked')
          if (isClicked) {
            verificaItemAtivo.classList.remove('clicked')
          }
        }
      }

      var div = document.getElementById(value)
      var isClickedItemClicado = div.classList.contains('clicked')
      if (isClickedItemClicado) {
        div.classList.remove('clicked')
      } else {
        div.classList.add('clicked')
      }
    },
    adicionarEtapa () {
      if (this.novoEtapa === null || this.novoEtapa === '') {
        return toast.warning('Preencha a descrição')
      }
      let etapa = {
        checkEtapa: false,
        novaEtapa: true,
        tipoMetadado: this.equipamento === true ? true : this.fluxoEscolhido,
        descricaoEtapa: this.novoEtapa.toUpperCase(),
        etapaId: uuidv4(),
        nivelPrioridadeEtapa: this.nivelPrioridade === null ? this.ProximoNivelEtapa : this.nivelPrioridade,
        subEtapas: []
      }

      let add = {
        Metadado: this.fluxoEscolhido,
        etapaId: etapa.etapaId,
        etapa: etapa.descricaoEtapa,
        nivelPrioridadeEtapa: this.nivelPrioridade === null ? this.ProximoNivelEtapa : this.nivelPrioridade,
        subEtapa: []
      }
      this.$emit('addNovaEtapa', add)
      this.$emit('tabelaNovaEtapa', etapa)
      this.novoEtapa = null
      this.fecharPopUptAdd()
    },
    EditarEtapa () {
      var editarEtapa = {
        etapaId: this.EtapaId,
        etapa: this.novoEtapa.toUpperCase(),
        nivelPrioridadeEtapa: this.nivelPrioridade
      }
      this.$emit('editarEtapa', editarEtapa)
      this.$emit('tabelaEditaEtapa', editarEtapa)
      this.fecharPopUptAdd()
    },
    adicionarSubEtapa () {
      // Chamado #20155 (item 4, ZOP-63): descricao da sub-etapa deixou de ser
      // obrigatoria. adicionarEtapa segue exigindo — o pedido e so pra sub-etapa.
      let subEtapa = {
        etapaIdGrupoId: this.EtapaId,
        checkTodosItens: false,
        exclusao: false,
        metadado: this.tipometadado,
        expandir: true,
        adicao: true,
        edicao: true,
        colorStatus: 'rgb(212, 238, 253)',
        colorFonte: 'rgb(0, 55, 137)',
        descricaoEdicao: 'AG. ENVIO NOVA SUBETAPA',
        descricaoEtapa: (this.novoEtapa || '').toUpperCase(),
        etapaId: uuidv4(),
        nivelPrioridadeEtapa: this.nivelPrioridade === null ? this.ProximoNivelSubEtapa : this.nivelPrioridade,
        itens: []
      }
      let novaSubEtapa = {
        etapaId: this.EtapaId,
        subEtapa: subEtapa,
        nivelPrioridadeEtapa: this.nivelPrioridade === null ? this.ProximoNivelSubEtapa : this.nivelPrioridade
      }

      let add = {
        etapaId: this.EtapaId,
        subEtapa: subEtapa.descricaoEtapa,
        nivelPrioridadeEtapa: this.nivelPrioridade === null ? this.ProximoNivelSubEtapa : this.nivelPrioridade,
        subEtapaId: subEtapa.etapaId,
        itens: []
      }
      if (this.etapaExistente === false || this.etapaExistente === undefined) {
        this.$emit('addNovaSubEtapaObjSemNovaEtapa', add)
      } else {
        this.$emit('addNovaSubEtapa', add)
      }
      this.$emit('novaSubEtapa', novaSubEtapa)
      this.novoEtapa = null
      this.fecharPopUptAdd()
    },
    EditarSubEtapa () {
      var editarSubEtapas = {
        etapaId: this.EtapaId,
        subEtapaId: this.subEtapaId,
        subEtapa: (this.novoEtapa || '').toUpperCase(),
        nivelPrioridadeEtapa: this.nivelPrioridade
      }
      this.$emit('editaSubEtapa', editarSubEtapas)
      this.$emit('tabelaSubEditaEtapa', editarSubEtapas)
      this.fecharPopUptAdd()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/TemplateDetail/GroupDetail/addGroup/addGroup.js